/**
 * 设备唯一指纹
 */

import FingerprintJS from '@hancomac/fingerprintjs'

const state = () => ({
  visitorId: null,
})

const getters = {
  visitorId(state) {
    return state.visitorId
  },
}

const mutations = {
  setVisitorId(state, id) {
    state.visitorId = id
  },
}

const actions = {
  async generateVisitorId({ state, commit }) {
    if (state.visitorId) return { visitorId: state.visitorId }
    const fp = await FingerprintJS.load()
    const { visitorId } = await fp.get()
    commit('setVisitorId', visitorId)
    return { visitorId }
  },
}

export default { state, getters, mutations, actions }
